export default {
  ErrorBoundary: {
    somethingWentWrong: 'Oops! Something went wrong!',
    tryAgain: 'Try again',
    more: 'More',
  },
};
